import { EmbeddedShell } from "./EmbeddedShell";
import { StandaloneShell } from "./StandaloneShell";

// Host-mode detection (modules/04 §3): an iframe inside a police system vs.
// standalone in a Citrix-published Chrome.

export function AppRoot() {
  const isEmbedded = window.self !== window.top;
  return isEmbedded ? <EmbeddedShell /> : <StandaloneShell />;
}
